var map = {
	"./introduce-1.png": "QtM5",
	"./introduce-2.png": "G50G",
	"./introduce-3.png": "G2yK",
	"./introduce-green-1.png": "UHie",
	"./introduce-green-2.png": "wfhw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGC8";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/introduce\-.*\.png$
// module id = wGC8
// module chunks = 1